import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useProfileQuery } from "@/queries/user/profile";
import { Spinner } from "@fluentui/react-components";

import "@/styles.css";

const Landing = () => {
  const { profile } = useProfileQuery();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Venturous";
  }, []);

  useEffect(() => {
    if (!profile) {
      // Fetch from server
      return;
    } else if (profile.userType.includes("Candidate")) {
      navigate("/dashboard");
    } else {
      navigate("/opportunities");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  return (
    <div className="h-full flex flex-col gap-8 justify-center items-center">
      <Spinner size="huge" />
      <div className="flex flex-col gap-1 text-center">
        <p className="text-2xl leading-6 font-semibold tracking-[-0.18px] text-[#22234A]">
          Welcome to Venturous
        </p>
        <p className="text-base font-medium text-[#727E94]">
          We&apos;re fetching your information...
        </p>
      </div>
    </div>
  );
};

export default Landing;
